export default __webpack_public_path__ + "static/media/tirupati.fcdffd63.jpeg";